// extracted by mini-css-extract-plugin
export default {"clientsView":"Clients_clientsView__iHZkx"};